import type { FaireProductEntity } from "../../entity_types/product";

export const p_y5v8fd8yg4: FaireProductEntity = {
  token: "p_y5v8fd8yg4",
  type: "product",
  name: "Floral Charm & Pearl Dangle",
  brandToken: "b_h93v6v8mbm",
  brandName: "Aurora Boheme",
  imageUrl: "https://cdn.faire.com/fastly/f368353107ddfbd35b6447285780e8f454e8e8f20d695e6e157412a227200a04.jpeg",
  galleryImageUrls: [],
  priceDollars: 20.79,
  description: "Hypoallergenic, Surgical grade Stainless steel - 24k Gold Plated findings. NICKEL FREE! \n\nHandcrafted with love by Savannah of Aurora Boheme \n",
  tags: [],
  msrpDollars: 41.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:57.930Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
